import { useEffect, useState } from "react";
import CandidatesApplyService from "../../API/Candidates/CandidatesApplyService";
import { PuzzleIcon } from "../../Icons/Icons";
import { FlagChile, FlagArgentina, FlagPeru, FlagBrasil, FlagColombia, FlagMexico, FlagEcuador, FlagUruguay } from "../../Icons/Flags";

import "./cardJob.sass";
import { jobsTranslate } from "../../i18n/translatedMessages";

const flag = {
	Brasil: <FlagBrasil width="25" height="25" />,
	Chile: <FlagChile width="25" height="25" />,
	Argentina: <FlagArgentina width="25" height="25" />,
	Perú: <FlagPeru width="25" height="25" />,
	Colombia: <FlagColombia width="25" height="25" />,
	México: <FlagMexico width="25" height="25" />,
	Ecuador: <FlagEcuador width="25" height="25" />,
	Uruguay: <FlagUruguay width="25" height="25" />,
};

export const CardJob = ({ id, area, title, city, country, jobApply, loadApplies, nameCompany }) => {
	const [loading, setLoading] = useState(false);
	const user = JSON.parse(localStorage.getItem("user")).id;
	const [unapply, setUnaply] = useState(false);

	useEffect(() => {
		setUnaply(jobApply);
	}, [jobApply]);

	const handleApply = async () => {
		setLoading(true);
		await CandidatesApplyService.apply(user, id);
		setUnaply(false);
		setLoading(await loadApplies());
	};

	const handleUnapply = async () => {
		setLoading(true);
		await CandidatesApplyService.unapply(user, id);
		setUnaply(true);
		setLoading(await loadApplies());
	};

	return (
		<>
			<div className="job-card" style={{ minWidth: "18rem" }}>
				<div className="card-body d-flex flex-column justify-content-between" style={{ height: "300px" }}>
					<div className="row">
						<div className="col d-flex flex-column">
							<div className="d-flex justify-content-between">
								<p className="" style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
									{nameCompany}
								</p>
								<p>{id}</p>
							</div>
							<h5 className="bold">{title}</h5>
							<div className="fs-6 d-flex">
								<div className="flag me-2">{flag[country]}</div>
								{city}
								{city ? "," : ""} {country}
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<hr />
							<div className="row">
								<div className="col-1">
									<PuzzleIcon />
								</div>
								<div className="col">
									<p className="fs-6 m-0">{area}</p>
									<p className="label">Area</p>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							{unapply ? (
								<button className="btn btn-postulation d-flex align-items-center justify-content-between" onClick={handleApply}>
									{jobsTranslate.applyToJobBnt}
									{loading && (
										<span className="ms-3">
											<Spinner />
										</span>
									)}
								</button>
							) : (
								<button className="btn btn-no-postulation d-flex align-items-center justify-content-between" onClick={handleUnapply}>
									{jobsTranslate.removeApplyBtn}
									{loading && (
										<span className="ms-3">
											<Spinner />
										</span>
									)}
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

const Spinner = () => <div className="lds-dual-ring"></div>;
